import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from '@mui/material';

interface ConfirmDialogProps {
    open: boolean;
    title?: string;
    description?: string;
    confirmText?: string;
    cancelText?: string;
    onClose: () => void;
    onConfirm: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    open,
    title = 'Confirmar Ação',
    description = 'Você tem certeza que deseja continuar?',
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    onClose,
    onConfirm
}) => {
    return (
        <Dialog open={open}
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: 3,
                    border: '1px solid var(--border-strong)',
                    boxShadow: 'var(--shadow-lg)',
                    padding: 2,
                    backgroundColor: 'var(--surface)',
                    backgroundImage: 'none',
                    color: 'var(--text)',
                    minWidth: 400,
                },
            }}
            onClose={onClose}>
            <DialogTitle sx={{ color: 'var(--text)' }}>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ color: 'var(--text-muted)' }}>{description}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">{cancelText}</Button>
                <Button onClick={onConfirm} color="primary" variant="contained">{confirmText}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
